import "./App.css";
import { AppStateProvider, useAppState } from "./state/appState";
import AppShell from "./features/app/AppShell";
import { useEffect, useState } from "react";
import { startDemoSimulator, stopDemoSimulator } from "./services/demoSimulator";
import { startTelemetrySimulator, stopTelemetrySimulator } from "./services/telemetrySimulator";
import CberrySplashScreen from "./CberrySplashScreen";

function App() {
  const [showSplash, setShowSplash] = useState(true);

  return (
    <AppStateProvider>
      <div className="App">
        {showSplash && <CberrySplashScreen onDone={() => setShowSplash(false)} />}
        <DemoGate />
        <AppShell />
      </div>
    </AppStateProvider>
  );
}

function DemoGate() {
  const state = useAppState();
  useEffect(() => {
    if (process.env.REACT_APP_DEMO_SIM === "true") {
      startDemoSimulator((action) => state.actions?.dispatchOverride?.(action) ?? null);
      startTelemetrySimulator(
        (action) => state.actions?.dispatchOverride?.(action) ?? null,
        state.nodes || []
      );
      return () => {
        stopTelemetrySimulator();
        stopDemoSimulator();
      };
    }
    return undefined;
  }, [state]);
  return null;
}

export default App;
